export default "__VITE_ASSET__CjY4JApQ__"